<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-2">
          <!-- <dashboard-menu-component :permissions="permissions" :irr="irr" :baseUrls="baseUrls"></dashboard-menu-component> -->
        </div>
        <div class="col-md-10" v-if="route == 'create'">
          <irr-request-form-component :route="route" :csrf_token="csrf_token" :errors="errors" :existingData="existingData" :maxRadius="maxRadius"></irr-request-form-component>
        </div>
        <div class="col-md-10" v-if="route == 'index'">
          <irr-request-list-component :route="route" :permissions="permissions" :irrRequests="irrRequests"></irr-request-list-component>
        </div>
        <div class="col-md-10" v-if="route == 'show'">
          <irr-request-data-component :route="route" :csrf_token="csrf_token" :userDisplayName="userDisplayName" :permissions="permissions" :irrRequest="irrRequest"></irr-request-data-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      props: {
        irr: Object,
        route: String,
        permissions: Object,
        errors: Array,
        existingData: [Object, Array],
        irrRequests: [Object, Array], //multiple IRR Requests
        irrRequest: [Object, Array],  //single IRR Request
        userDisplayName: String,
        maxRadius: Number,
      },
      data: function() {
        return {
          baseUrls: {
            resourceBaseUrl: '/resource/',
            irrBaseUrl: '/irr/',
            userBaseUrl: '/user/'
          },
          csrf_token: $('meta[name="csrf-token"]').attr('content'),
        }
      },
      mounted(){
        //
      }
    }
</script>
